import React from 'react';
import Info from '../../contenedores/Info';

const Forbidden = ({ history }) => {
  return <Info history={history} es404={false} />
};

export default Forbidden;
